import { call, delay, put, takeEvery, takeLatest } from 'redux-saga/effects';

import * as accountSettingsTypes from '../actions/accountSettingsActionTypes';
import * as bannerTypes from '../actions/bannerActionTypes';
import * as customAudioPlaylistTypes from '../actions/customAudioPlaylistActionTypes';
import * as dailyQuizTypes from '../actions/dailyQuizActionTypes';
import * as dashboardTypes from '../actions/dashboardActionType';
import * as friendProfileTypes from '../actions/friendProfileActionType';
import * as helpPopupsTypes from '../actions/helpPopupsActionTypes';
import * as ManageSubscriptionTypes from '../actions/manageSubscriptionActionTypes';
import * as myProfileTypes from '../actions/MyFriendsActionTypes';
import * as notificationMessageActionTypes from '../actions/notificationMessageActionTypes';
import * as personalizedStudyTypes from '../actions/personalizedStudyActionTypes';
import * as practiceExamTypes from '../actions/practiceExamActionTypes';
import * as referralTypes from '../actions/referralActionTypes';
import * as resourcesTypes from '../actions/resourcesActionTypes';
import * as selfPromotionTypes from '../actions/selfPromotionActionTypes';
import * as signUpTypes from '../actions/signUpActionTypes';
import * as studyTypes from '../actions/studyMainActionTypes';
import * as submitAQuestionTypes from '../actions/submitAQuestionActionTypes';
import * as types from '../actions/userActionTypes';
import {
  getMyReferralsService,
  sendReferralService,
} from '../services/referralService';
import {
  answerSelfPromotionService,
  getPendingSelfPromotionsService,
} from '../services/selfPromotionService';
import {
  activateReceiveQuestionsNotificationSagas,
  applyCouponUserSaga,
  customerSiteMockUp,
  editPaymentDetailsSagas,
  getAllFavoriteQuestionsSaga,
  getAllRatesSaga,
  getAvailableQualForDailyQuizSaga,
  getCustomerSiteMockUpSaga,
  getCustomSyncSaga,
  getDisabledQuestionsSagas,
  getFavoriteQuestionsSaga,
  getLastCouponUserSaga,
  getNotificationPreferencesSagas,
  getSubmittedQuestionsSaga,
  loadPossibleCyclesForUpdateExam,
  loadPossibleCyclesForUserSagas,
  loadUserSubscriptionSagas,
  removeAllFavoriteQuestionsSaga,
  removeFavoriteQuestionsSaga,
  resetAllDisabledQuestionsSagas,
  resetDisabledIndividualQuestionSagas,
  sendNotificationPreferencesSagas,
  setStudySpeedSettingsSaga,
  updateCustomSyncSaga,
  updateEmailSaga,
  updateFlashcardOnlySaga,
  updatePasswordSaga,
  updatePersonalDataSagas,
  updateProfilePrivacySaga,
  updateRatingExamSagas,
  updateSwitchPfeSktSaga,
  updateTimezoneSaga,
  updateUsernameSaga,
  uploadProfileImageSagas,
} from './accountSettingsSagas';
import { getBannersActiveSaga } from './bannerSagas';
import {
  deleteCustomPlaylistSaga,
  getCustomPlaylistsSaga,
} from './customAudioPlaylistSagas';
import {
  checkDailyQuizStatusSaga,
  checkQualDailyQuizStatusSaga,
  getDailyQuizQuestionsSagas,
  getDailyQuizResultsSagas,
  loadDailyQuizSaga,
  loadQualDailyQuizSaga,
  sendAnswerSagas,
  submitDailyQuizSaga,
  submitQualDailyQuizSaga,
  updateDailyQuizSaga,
  updateQualDailyQuizSaga,
} from './dailyQuizSagas';
import {
  getActivity,
  getBadgesSagas,
  getDailyQuizHistorySagas,
  getEveryoneLeaderboard,
  getFeaturedBlogSagas,
  getFeaturedForumSagas,
  getFeaturedPodcastSagas,
  getFriendLeaderboard,
  getInviteAFriendSagas,
  getOneDailyQuizHistorySagas,
  getOneQualDailyQuizHistorySagas,
  getQualDailyQuizHistorySagas,
  getRecomendedTopicsSagas,
  getScoringHistorySagas,
  getStats,
  loadDashboardHeaderInfoSaga,
  loadPointsThisWeekSaga,
  setUserCycleSaga,
} from './dashboardSaga';
import {
  getFriendActivity,
  getFriendBadgesSagas,
  getFriendHeaderSagas,
  getFriendProfileSagas,
  getFriendScoringHistorySagas,
  getFriendStats,
} from './friendProfileSagas';
import { disableQuestionSagas, reportQuestionSagas } from './helpPopupsSagas';
import {
  activateSubscriptionSagas,
  cancelScheduleOnSwitchIosToStripeSaga,
  cancelSubscriptionSaga,
  changeSubscriptionSaga,
  renewSubscriptionSaga,
  revertCancellationSaga,
  switchSubscriptionToStripeSaga,
  updateSubscriptionPlanSagas,
  upgradeubscriptionSaga,
} from './manageSubscriptionSagas';
import {
  getFriendRequestNotificationsSaga,
  laodFriendsSagas,
  removeFriendSagas,
  resolveFriendRequestSagas,
  sendFriendsRequestSagas,
} from './myFriendsSagas';
import {
  getNotificationMessageSaga,
  setNotificationMessageSeenSaga,
} from './notificationMessageSaga';
import {
  buildChapterStudyPlanSaga,
  getAvailableChaptersSaga,
  loadChapterStudyPlanSaga,
  saveSelectedChaptersSaga,
} from './personalizedStudySagas';
import {
  generateCustomPracticeExamSaga,
  getCustomPracticeExamReferencesSaga,
  getCustomPracticeExamSettingsSaga,
  getPracticeExamQuestionsSagas,
  getWeeklyPracticeExamsSagas,
  practiceExamResultsSagas,
  startPracticeExamSagas,
  submitPracticeExamResultsSagas,
  updatePracticeExamResultsSagas,
} from './practiceExamSagas';
import {
  loadFeaturedBlog,
  loadPostCategories,
  loadResourcesPosts,
} from './resourcesSagas';
import {
  checkCouponSagas,
  checkEmailExistsSagas,
  getAllPublicRatesSagas,
  getQualsDataSaga,
  getReferencesDataSagas,
  loadPlansSagas,
  makeSubscriptionSagas,
} from './signUpSagas';
import {
  checkChapterInReviewSagas,
  contentByRefSaga,
  contentByWarfareQualsSaga,
  favoriteQuestionSaga,
  getAudioPlaylistProgressWorkerSaga,
  getAudioPlaylistSagas,
  getContentByStudyAllSaga,
  getQuestionsByChapterSaga,
  getQuestionsByPersonalizedStudyAllSaga,
  getQuestionsByQualsSaga,
  getQuestionsByRateSaga,
  getStudyFavoriteQuestionSaga,
  getStudyMyFavoriteQuestionSaga,
  getStudyMySubmittedQuestionSaga,
  getStudySubmittedQuestionSaga,
  loadSktBibsCountersSaga,
  pdfByRerefenceSaga,
  postExamChecklistPdfSaga,
  QualFromIdSaga,
  resetChapterSaga,
  sendAnswerSaga,
  updateAudioPlaylistProgressWorkerSaga,
  updateDisabledChapterSagas,
  updateUserAnswersSagas,
} from './studyMainSagas';
import {
  deleteUserSubmittedQuestionSaga,
  editSubmitQuestionSaga,
  getUserSubmittedQuestionsSaga,
  submitAQuestionSaga,
} from './submitAQuestionSagas';
import {
  getUserProgressOnChaptersSaga,
  loginSaga,
  logoutSaga,
  requestPassword,
  resetPasswordSagas,
  updateUserSettingQualForDailyQuizSaga,
  verifyIsMaintenanceSaga,
} from './userSagas';

export function* watchUserAuthentication() {
  yield takeLatest(types.LOGIN_USER, loginSaga); // here you have to add the action/sagas excecution
}

export function* watchUserLogout() {
  yield takeLatest(types.LOGOUT_USER, logoutSaga);
}

export function* watchUserRequestPassword() {
  yield takeLatest(types.REQUEST_PASSWORD, requestPassword);
}

export function* watchresetPasswordSagas() {
  yield takeLatest(types.RESET_PASSWORD, resetPasswordSagas);
}

export function* watchUserProgressOnChaptersSaga() {
  yield takeLatest(
    types.GET_TRIAL_USER_PROGRESS,
    getUserProgressOnChaptersSaga,
  );
}

export function* watchStudyContentByRef() {
  yield takeLatest(studyTypes.GET_CONTENT_BY_REFERENCE, contentByRefSaga); // here you have to add the action/sagas excecution
}

export function* watchLoadSktData() {
  yield takeLatest(studyTypes.LOAD_SKT_BIBS_COUNTERS, loadSktBibsCountersSaga);
}

export function* watchStudyByFavoriteQuestions() {
  yield takeLatest(
    studyTypes.GET_QUESTIONS_BY_FAVORITE,
    getStudyFavoriteQuestionSaga,
  );
}

export function* watchStudyByMyFavoriteQuestions() {
  yield takeLatest(
    studyTypes.GET_QUESTIONS_BY_MY_FAVORITE,
    getStudyMyFavoriteQuestionSaga,
  );
}

export function* watchStudyBySubmittedQuestions() {
  yield takeLatest(
    studyTypes.GET_QUESTIONS_BY_SUBMITTED,
    getStudySubmittedQuestionSaga,
  );
}

export function* watchStudyByMySubmittedQuestions() {
  yield takeLatest(
    studyTypes.GET_QUESTIONS_BY_MY_SUBMITTED,
    getStudyMySubmittedQuestionSaga,
  );
}

export function* watchStudyContentByWarfareQuals() {
  yield takeLatest(
    studyTypes.GET_CONTENT_BY_WARFARE_QUALS,
    contentByWarfareQualsSaga,
  );
}

export function* watchGetQualFromId() {
  yield takeLatest(studyTypes.GET_QUAL_FROM_ID, QualFromIdSaga);
}

export function* watchStudyContentByStudyAll() {
  yield takeLatest(
    studyTypes.GET_CONTENT_BY_STUDY_ALL,
    getContentByStudyAllSaga,
  );
}

// ---- Study Plan Login

// ---- Manage Subscription Page

export function* watchCancelSubscription() {
  yield takeLatest(
    ManageSubscriptionTypes.CANCEL_SUBSCRIPTION,
    cancelSubscriptionSaga,
  );
}

export function* watchRevertCancellation() {
  yield takeLatest(
    ManageSubscriptionTypes.REVERT_CANCELLATION,
    revertCancellationSaga,
  );
}

export function* watchswitchSubscriptionToStripe() {
  yield takeLatest(
    ManageSubscriptionTypes.SWITCH_TO_STRIPE_SUBSCRIPTION,
    switchSubscriptionToStripeSaga,
  );
}

export function* watchCancelScheduleOnSwitchIosToStripe() {
  yield takeLatest(
    ManageSubscriptionTypes.CANCEL_SCHEDULE_ON_SWITCH_IOS_STRIPE,
    cancelScheduleOnSwitchIosToStripeSaga,
  );
}

export function* watchRenewSubscription() {
  yield takeLatest(
    ManageSubscriptionTypes.RENEW_SUBSCRIPTION,
    renewSubscriptionSaga,
  );
}

export function* watchChangeSubscription() {
  yield takeLatest(
    ManageSubscriptionTypes.CHANGE_SUBSCRIPTION,
    changeSubscriptionSaga,
  );
}

export function* watchUpgradeSubscription() {
  yield takeLatest(
    ManageSubscriptionTypes.UPGRADE_SUBSCRIPTION,
    upgradeubscriptionSaga,
  );
}

export function* watchActivateSubscription() {
  yield takeLatest(
    ManageSubscriptionTypes.ACTIVATE_SUBSCRIPTION,
    activateSubscriptionSagas,
  );
}

export function* watchUpdateSubscriptionPlan() {
  yield takeLatest(
    ManageSubscriptionTypes.UPDATE_SUBSCRIPTION_PLAN,
    updateSubscriptionPlanSagas,
  );
}
// ----- My Friends

export function* watchLoadFriends() {
  yield takeLatest(myProfileTypes.LOAD_FRIENDS, laodFriendsSagas);
}

export function* watchRemoveFriend() {
  yield takeLatest(myProfileTypes.REMOVE_FRIEND, removeFriendSagas);
}

export function* watchResolveFriendRequest() {
  yield takeLatest(
    myProfileTypes.RESOLVE_FRIEND_REQUEST,
    resolveFriendRequestSagas,
  );
}

export function* watchSendFriendsRequest() {
  yield takeLatest(
    myProfileTypes.SEND_FRIENDS_REQUEST,
    sendFriendsRequestSagas,
  );
}

// ---- Sign Up
export function* watchGetAllPublicRates() {
  yield takeLatest(signUpTypes.GET_ALL_PUBLIC_RATES, getAllPublicRatesSagas);
}

export function* watchGetReferencesData() {
  yield takeLatest(signUpTypes.GET_REFERENCES, getReferencesDataSagas);
}

export function* watchGetQualsData() {
  yield takeLatest(signUpTypes.GET_QUALS_DATA, getQualsDataSaga);
}
export function* watchLoadPlans() {
  yield takeLatest(signUpTypes.GET_PLANS, loadPlansSagas);
}

export function* watchCheckEmailExists() {
  yield takeLatest(signUpTypes.CHECK_EMAIL_EXISTS, checkEmailExistsSagas);
}

export function* watchCheckCoupon() {
  yield takeLatest(signUpTypes.CHECK_COUPON, checkCouponSagas);
}

export function* watchMakeSubscription() {
  yield takeLatest(signUpTypes.MAKE_SUBSCRIPTION, makeSubscriptionSagas);
}

// ---- Questions / Answers flow

export function* watchGetQuestionsByQuals() {
  yield takeLatest(studyTypes.GET_QUESTIONS_BY_QUALS, getQuestionsByQualsSaga);
}

export function* watchGetQuestionsByChapter() {
  yield takeLatest(
    studyTypes.GET_QUESTIONS_BY_CHAPTER,
    getQuestionsByChapterSaga,
  );
}

export function* watchGetQuestionsByRate() {
  yield takeLatest(studyTypes.GET_QUESTIONS_BY_RATE, getQuestionsByRateSaga);
}

export function* watchGetQuestionsByPersonalizedStudyAll() {
  yield takeLatest(
    studyTypes.GET_QUESTIONS_BY_PERSONALIZED_STUDY_ALL,
    getQuestionsByPersonalizedStudyAllSaga,
  );
}

export function* watchUpdateUserAnswers() {
  yield takeLatest(studyTypes.UPDATE_USERANSWERS, updateUserAnswersSagas);
}

export function* watchUpdateDisabledChapter() {
  yield takeLatest(
    studyTypes.UPDATE_DISABLED_CHAPTER,
    updateDisabledChapterSagas,
  );
}

export function* watchGetAudioPlaylist() {
  yield takeLatest(studyTypes.GET_AUDIO_PLAYLIST, getAudioPlaylistSagas);
}

export function* watchCheckChapterInReview() {
  yield takeLatest(
    studyTypes.CHECK_CHAPTER_IN_REVIEW,
    checkChapterInReviewSagas,
  );
}

export function* watchSendAnswer() {
  yield takeLatest(studyTypes.SEND_ANSWER, sendAnswerSaga);
}

export function* watchFavoriteQuestion() {
  yield takeLatest(studyTypes.FAVORITE_QUESTION, favoriteQuestionSaga);
}

export function* watchResetChapter() {
  yield takeLatest(studyTypes.RESET_CHAPTER, resetChapterSaga);
}

// Account Settings

export function* watchGetAllRates() {
  yield takeLatest(accountSettingsTypes.GET_ALL_RATES, getAllRatesSaga);
}

export function* watchUpdateUsername() {
  yield takeLatest(accountSettingsTypes.UPDATE_USERNAME, updateUsernameSaga);
}

export function* watchUpdatePersonalData() {
  yield takeLatest(
    accountSettingsTypes.UPDATE_PERSONAL_DATA,
    updatePersonalDataSagas,
  );
}

export function* watchUpdateTimezone() {
  yield takeLatest(accountSettingsTypes.UPDATE_TIMEZONE, updateTimezoneSaga);
}

export function* watchUpdateProfilePrivacy() {
  yield takeLatest(
    accountSettingsTypes.UPDATE_PROFILE_PRIVACY,
    updateProfilePrivacySaga,
  );
}

export function* watchUpdateSwitchPfeSkt() {
  yield takeLatest(accountSettingsTypes.SWITCH_PFE_SKT, updateSwitchPfeSktSaga);
}

export function* watchUpdateFlashCardOnly() {
  yield takeLatest(
    accountSettingsTypes.UPDATE_FLASHCARD_ONLY,
    updateFlashcardOnlySaga,
  );
}

export function* watchUploadProfileImage() {
  yield takeLatest(
    accountSettingsTypes.UPLOAD_PROFILE_IMAGE,
    uploadProfileImageSagas,
  );
}

export function* watchUpdateEmail() {
  yield takeLatest(accountSettingsTypes.UPDATE_EMAIL, updateEmailSaga);
}

export function* watchUpdatePassword() {
  yield takeLatest(accountSettingsTypes.UPDATE_PASSWORD, updatePasswordSaga);
}

export function* watchUpdateRatingExam() {
  yield takeLatest(
    accountSettingsTypes.UPDATE_RATING_EXAM,
    updateRatingExamSagas,
  );
}

export function* watchResetAllDisabledQuestions() {
  yield takeLatest(
    accountSettingsTypes.RESET_ALL_DISABLED_QUESTIONS,
    resetAllDisabledQuestionsSagas,
  );
}

export function* watchRemoveAllFavoriteQuestions() {
  yield takeLatest(
    accountSettingsTypes.REMOVE_ALL_FAVORITE_QUESTIONS,
    removeAllFavoriteQuestionsSaga,
  );
}

export function* watchResetDisabledIndividualQuestion() {
  yield takeLatest(
    accountSettingsTypes.RESET_DISABLED_INDIVIDUAL_QUESTION,
    resetDisabledIndividualQuestionSagas,
  );
}

export function* watchGetDisabledQuestions() {
  yield takeLatest(
    accountSettingsTypes.GET_DISABLED_QUESTIONS,
    getDisabledQuestionsSagas,
  );
}

export function* watchGetFavoriteQuestions() {
  yield takeLatest(
    accountSettingsTypes.GET_FAVORITE_QUESTIONS,
    getFavoriteQuestionsSaga,
  );
}

export function* watchGetAllFavoriteQuestions() {
  yield takeLatest(
    accountSettingsTypes.GET_ALL_FAVORITE_QUESTIONS,
    getAllFavoriteQuestionsSaga,
  );
}

export function* watchGetSubmittedQuestions() {
  yield takeLatest(
    accountSettingsTypes.GET_SUBMITTED_QUESTIONS,
    getSubmittedQuestionsSaga,
  );
}

export function* watchRemoveFavoriteQuestions() {
  yield takeLatest(
    accountSettingsTypes.REMOVE_FAVORITE_QUESTIONS,
    removeFavoriteQuestionsSaga,
  );
}

export function* watchLoadPossibleCyclesForUser() {
  yield takeLatest(
    accountSettingsTypes.LOAD_POSSIBLE_CYCLES_FOR_USER,
    loadPossibleCyclesForUserSagas,
  );
}

export function* watchLoadPossibleCyclesForUpdateExam() {
  yield takeLatest(
    accountSettingsTypes.POSSIBLE_CYCLES_FOR_UPDATE_EXAM,
    loadPossibleCyclesForUpdateExam,
  );
}

export function* watchLoadUserSubscription() {
  yield takeLatest(
    accountSettingsTypes.LOAD_USER_SUBSCRIPTION,
    loadUserSubscriptionSagas,
  );
}

export function* watchEditPaymentDetails() {
  yield takeLatest(
    accountSettingsTypes.EDIT_PAYMENT_DETAILS,
    editPaymentDetailsSagas,
  );
}

export function* watchActivateReceiveQuestionsNotification() {
  yield takeLatest(
    accountSettingsTypes.ACTIVATE_RECEIVE_QUESTIONS_NOTIFICATION,
    activateReceiveQuestionsNotificationSagas,
  );
}

export function* watchGetDailyQuizQuestions() {
  yield takeLatest(
    dailyQuizTypes.GET_DAILY_QUIZ_QUESTIONS,
    getDailyQuizQuestionsSagas,
  );
}

export function* watchSendDailyQuizAnswer() {
  yield takeLatest(dailyQuizTypes.SEND_DAILY_QUIZ_ANSWER, sendAnswerSagas);
}

export function* watchGetDailyQuizResults() {
  yield takeLatest(
    dailyQuizTypes.GET_RESULTS_DAILY_QUIZ,
    getDailyQuizResultsSagas,
  );
}

export function* watchCheckDailyQuizStatus() {
  yield takeLatest(
    dailyQuizTypes.CHECK_DAILY_QUIZ_STATUS,
    checkDailyQuizStatusSaga,
  );
}

export function* watchCheckQualDailyQuizStatus() {
  yield takeLatest(
    dailyQuizTypes.CHECK_QUAL_DAILY_QUIZ_STATUS,
    checkQualDailyQuizStatusSaga,
  );
}

export function* watchLoadDailyQuiz() {
  yield takeLatest(dailyQuizTypes.LOAD_DAILY_QUIZ, loadDailyQuizSaga);
}

export function* watchLoadQualDailyQuiz() {
  yield takeLatest(dailyQuizTypes.LOAD_QUAL_DAILY_QUIZ, loadQualDailyQuizSaga);
}

export function* watchUpdateDailyQuiz() {
  yield takeLatest(dailyQuizTypes.UPDATE_DAYILY_QUIZ, updateDailyQuizSaga);
}

export function* watchUpdateQualDailyQuiz() {
  yield takeLatest(
    dailyQuizTypes.UPDATE_QUAL_DAILY_QUIZ,
    updateQualDailyQuizSaga,
  );
}

export function* watchSubmitDailyQuiz() {
  yield takeLatest(dailyQuizTypes.SUBMIT_DAILY_QUIZ, submitDailyQuizSaga);
}

export function* watchSubmitQualDailyQuiz() {
  yield takeLatest(
    dailyQuizTypes.SUBMIT_QUAL_DAILY_QUIZ,
    submitQualDailyQuizSaga,
  );
}

// DASHBOARD

// for my stats
export function* watchGetStats() {
  yield takeLatest(dashboardTypes.LOAD_STATS, getStats);
}

export function* watchLoadPointsThisWeekSaga() {
  yield takeLatest(
    dashboardTypes.LOAD_POINTS_THIS_WEEK,
    loadPointsThisWeekSaga,
  );
}

export function* watchLoadDashboardHeaderInfo() {
  yield takeLatest(
    dashboardTypes.LOAD_DASHBOARD_HEADER_INFO,
    loadDashboardHeaderInfoSaga,
  );
}

// for activity
export function* watchGetActivity() {
  yield takeLatest(dashboardTypes.LOAD_ACTIVITY, getActivity);
}
// for leaderboard
export function* watchGetFrieandLeaderboard() {
  yield takeLatest(
    dashboardTypes.LOAD_FRIEND_LEADERBOARD,
    getFriendLeaderboard,
  );
}
export function* watchGetScoringHistory() {
  yield takeLatest(dashboardTypes.GET_SCORING_HISTORY, getScoringHistorySagas);
}

export function* watchGetEveryoneLeaderboard() {
  yield takeLatest(
    dashboardTypes.LOAD_EVERYONE_LEADERBOARD,
    getEveryoneLeaderboard,
  );
}

export function* watchGetBadges() {
  yield takeLatest(dashboardTypes.GET_BADGES, getBadgesSagas);
}

export function* watchGetDailyQuizHistory() {
  yield takeLatest(
    dashboardTypes.GET_DAILY_QUIZ_HISTORY,
    getDailyQuizHistorySagas,
  );
}

export function* watchGetQualDailyQuizHistory() {
  yield takeLatest(
    dashboardTypes.GET_QUAL_DAILY_QUIZ_HISTORY,
    getQualDailyQuizHistorySagas,
  );
}

export function* watchGetOneDailyQuizHistory() {
  yield takeLatest(
    dashboardTypes.GET_ONE_DAILY_QUIZ_HISTORY,
    getOneDailyQuizHistorySagas,
  );
}

export function* watchGetOneQualDailyQuizHistory() {
  yield takeLatest(
    dashboardTypes.GET_ONE_QUAL_DAILY_QUIZ_HISTORY,
    getOneQualDailyQuizHistorySagas,
  );
}

export function* watchGetRecomendedTopics() {
  yield takeLatest(
    dashboardTypes.GET_RECOMENDED_TOPICS,
    getRecomendedTopicsSagas,
  );
}

export function* watchGetFeaturedBlog() {
  yield takeLatest(dashboardTypes.GET_FEATURED_BLOG, getFeaturedBlogSagas);
}

export function* watchGetInviteAFriend() {
  yield takeLatest(dashboardTypes.GET_INVITE_A_FRIEND, getInviteAFriendSagas);
}

export function* watchGetFeaturedPodcast() {
  yield takeLatest(
    dashboardTypes.GET_FEATURED_PODCAST,
    getFeaturedPodcastSagas,
  );
}

export function* watchGetFeaturedForum() {
  yield takeLatest(dashboardTypes.GET_FEATURED_FORUM, getFeaturedForumSagas);
}

// for HelpPopupus

export function* watchDisableQuestion() {
  yield takeLatest(helpPopupsTypes.DISABLE_QUESTION, disableQuestionSagas);
}

export function* watchReportQuestion() {
  yield takeLatest(helpPopupsTypes.REPORT_QUESTION, reportQuestionSagas);
}

export function* watchGetWeeklyPracticeExams() {
  yield takeLatest(
    practiceExamTypes.GET_WEEKLY_PRACTICE_EXAMS,
    getWeeklyPracticeExamsSagas,
  );
}

export function* watchgetPracticeExamQuestions() {
  yield takeLatest(
    practiceExamTypes.GET_PRACTICE_EXAM_QUESTIONS,
    getPracticeExamQuestionsSagas,
  );
}

export function* watchStartPracticeExam() {
  yield takeLatest(
    practiceExamTypes.START_PRACTICE_EXAM,
    startPracticeExamSagas,
  );
}

export function* watchUpdatePracticeExamResults() {
  yield takeLatest(
    practiceExamTypes.UPDATE_PRACTICE_EXAM_RESULTS,
    updatePracticeExamResultsSagas,
  );
}

export function* watchSubmitPracticeExamResults() {
  yield takeLatest(
    practiceExamTypes.SUBMIT_PRACTICE_EXAM,
    submitPracticeExamResultsSagas,
  );
}
export function* watchPracticeExamResults() {
  yield takeLatest(
    practiceExamTypes.PRACTICE_EXAM_RESULTS,
    practiceExamResultsSagas,
  );
}

// FRIEND PROFILE
export function* watchGetFriendStats() {
  yield takeLatest(friendProfileTypes.GET_FRIEND_STATS, getFriendStats);
}

export function* watchGetFriendActivity() {
  yield takeLatest(friendProfileTypes.GET_FRIEND_ACTIVITY, getFriendActivity);
}

export function* watchGetFriendBadges() {
  yield takeLatest(friendProfileTypes.GET_FRIEND_BADGES, getFriendBadgesSagas);
}
export function* watchGetFriendScoringHistory() {
  yield takeLatest(
    friendProfileTypes.GET_FRIEND_SCORING_HISTORY,
    getFriendScoringHistorySagas,
  );
}
export function* watchGetFriendProfile() {
  yield takeLatest(
    friendProfileTypes.GET_FRIEND_PROFILE,
    getFriendProfileSagas,
  );
}
export function* watchGetFriendHeader() {
  yield takeLatest(friendProfileTypes.GET_FRIEND_HEADER, getFriendHeaderSagas);
}

export function* watchGetNotificationPreferencesSagas() {
  yield takeLatest(
    accountSettingsTypes.GET_NOTIFICATION_PREFERENCES,
    getNotificationPreferencesSagas,
  );
}

export function* watchSendNotificationPreferencesSagas() {
  yield takeLatest(
    accountSettingsTypes.SEND_NOTIFICATION_PREFERENCES,
    sendNotificationPreferencesSagas,
  );
}

export function* watchLoadResourcesPosts() {
  yield takeLatest(
    // accountSettingsTypes.SEND_NOTIFICATION_PREFERENCES,
    resourcesTypes.LOAD_POSTS,
    loadResourcesPosts,
  );
}

export function* watchLoadPostCategories() {
  yield takeLatest(resourcesTypes.LOAD_CATEGORIES, loadPostCategories);
}

export function* watchLoadFeaturedBlog() {
  yield takeLatest(resourcesTypes.LOAD_FEATURED_BLOG, loadFeaturedBlog);
}

export function* watchSetUserCycle() {
  yield takeLatest(dashboardTypes.SET_USER_CYCLE, setUserCycleSaga);
}

// Banners
export function* watchBannersActive() {
  yield takeLatest(bannerTypes.GET_BANNERS_ACTIVE, getBannersActiveSaga);
}

// Customer Site Mocke-up
export function* watchCustomerSiteMockUp() {
  yield takeLatest(accountSettingsTypes.CUSTOMER_SITE, customerSiteMockUp);
}

export function* watchGetCustomerSiteMockUp() {
  yield takeLatest(
    accountSettingsTypes.GET_CUSTOMER_SITE_MOCK_UP,
    getCustomerSiteMockUpSaga,
  );
}

export function* watchGetNotificationMessages() {
  yield takeLatest(
    notificationMessageActionTypes.GET_NOTIFICATION_MESSAGES,
    getNotificationMessageSaga,
  );
}

export function* watchSetNotificationMessagesSeen() {
  yield takeLatest(
    notificationMessageActionTypes.NOTIFICATIONS_MESSAGE_SEEN,
    setNotificationMessageSeenSaga,
  );
}
export function* watchPdfByReference() {
  yield takeLatest(studyTypes.GET_PDF_BY_REFERENCE, pdfByRerefenceSaga);
}

export function* watchPostExamChecklistPdf() {
  yield takeLatest(
    studyTypes.GET_POST_EXAM_CHECKLIST_PDF,
    postExamChecklistPdfSaga,
  );
}

export function* watchApplyCouponUser() {
  yield takeLatest(accountSettingsTypes.APPLY_COUPON_USER, applyCouponUserSaga);
}

export function* watchGetLastCouponUser() {
  yield takeLatest(
    accountSettingsTypes.GET_LAST_COUPON_USER,
    getLastCouponUserSaga,
  );
}

// Submit A Question
export function* watchSubmitNewQuestion() {
  yield takeLatest(
    submitAQuestionTypes.SUBMIT_NEW_QUESTION,
    submitAQuestionSaga,
  );
}

export function* watchEditSubmitQuestion() {
  yield takeLatest(
    submitAQuestionTypes.EDIT_SUBMIT_QUESTION,
    editSubmitQuestionSaga,
  );
}

export function* watchGetUserSubmittedQuestions() {
  yield takeLatest(
    submitAQuestionTypes.GET_USER_SUBMITTED_QUESTIONS,
    getUserSubmittedQuestionsSaga,
  );
}

export function* watchDeleteUserSubmittedQuestion() {
  yield takeLatest(
    submitAQuestionTypes.DELETE_USER_SUBMITTED_QUESTION,
    deleteUserSubmittedQuestionSaga,
  );
}

export function* watchSetStudySpeedSettings() {
  yield takeLatest(
    accountSettingsTypes.SET_STUDY_SPEED_SETTINGS,
    setStudySpeedSettingsSaga,
  );
}

export function* watchGetAvailableQualForDailyQuiz() {
  yield takeLatest(
    accountSettingsTypes.GET_AVAILABLE_QUALS_FOR_DAILY_QUIZ,
    getAvailableQualForDailyQuizSaga,
  );
}

export function* watchUpdateUserSettingQualForDailyQuizSaga() {
  yield takeLatest(
    types.UPDATE_USER_SETTING_QUAL_FOR_DAILY_QUIZ,
    updateUserSettingQualForDailyQuizSaga,
  );
}

export function* watchVerifyIsMaintenanceSaga() {
  yield takeLatest(types.VERIFY_IS_MAINTENANCE, verifyIsMaintenanceSaga);
}

export function* watchgetFriendRequestNotifications() {
  yield takeLatest(
    myProfileTypes.LOAD_FRIEND_REQUEST_NOTIFICATIONS,
    getFriendRequestNotificationsSaga,
  );
}

export function* watchGetAudioPlaylistProgressSaga() {
  yield takeEvery(
    studyTypes.GET_AUDIO_PLAYLISTS_PROGRESS,
    getAudioPlaylistProgressWorkerSaga,
  );
}

export function* watchUpdateAudioPlaylistProgressSaga() {
  yield takeEvery(
    studyTypes.UPDATE_AUDIO_PLAYLIST_PROGRESS,
    updateAudioPlaylistProgressWorkerSaga,
  );
}

export function* watchFetchMyReferrals() {
  yield takeLatest(referralTypes.FETCH_MY_REFERRALS, fetchMyReferralsSaga);
}

export function* watchSendReferral() {
  yield takeLatest(referralTypes.SEND_REFERRAL, sendReferralSaga);
}

function* fetchMyReferralsSaga() {
  try {
    yield put({ type: referralTypes.SET_REFERRALS_LOADING, loading: true });
    yield put({ type: referralTypes.SET_REFERRALS_ERROR, error: null });

    const response = yield call(getMyReferralsService);
    yield put({
      type: referralTypes.SET_REFERRALS,
      referrals: response.referrals,
    });
  } catch (error) {
    yield put({
      type: referralTypes.SET_REFERRALS_ERROR,
      error: error.response?.data?.error || 'Error fetching referrals',
    });
  } finally {
    yield put({ type: referralTypes.SET_REFERRALS_LOADING, loading: false });
  }
}

function* sendReferralSaga(action) {
  try {
    yield put({ type: referralTypes.SET_SENDING_INVITATION, sending: true });
    yield put({ type: referralTypes.SET_REFERRALS_ERROR, error: null });
    yield put({ type: referralTypes.CLEAR_INVITATION_MESSAGE });

    const response = yield call(sendReferralService, action.emailTo);
    yield put({
      type: referralTypes.SET_INVITATION_MESSAGE,
      message: 'Invitation sent successfully!',
    });
    yield delay(3000);
    yield put({ type: referralTypes.CLEAR_INVITATION_MESSAGE });
    yield put({ type: referralTypes.FETCH_MY_REFERRALS });
  } catch (error) {
    yield put({
      type: referralTypes.SET_REFERRALS_ERROR,
      error: error.response?.data?.error || 'Error sending referral',
    });
    yield delay(5000);
    yield put({ type: referralTypes.SET_REFERRALS_ERROR, error: null });
  } finally {
    yield put({ type: referralTypes.SET_SENDING_INVITATION, sending: false });
  }
}

export function* watchGetCustomPlaylists() {
  yield takeLatest(
    customAudioPlaylistTypes.GET_CUSTOM_PLAYLISTS,
    getCustomPlaylistsSaga,
  );
}

export function* watchDeleteCustomPlaylist() {
  yield takeLatest(
    customAudioPlaylistTypes.DELETE_CUSTOM_PLAYLIST,
    deleteCustomPlaylistSaga,
  );
}

export function* watchGenerateCustomPracticeExam() {
  yield takeLatest(
    practiceExamTypes.GENERATE_CUSTOM_PRACTICE_EXAM,
    generateCustomPracticeExamSaga,
  );
}

export function* watchGetCustomPracticeExamReferences() {
  yield takeLatest(
    practiceExamTypes.GET_CUSTOM_PRACTICE_EXAM_REFERENCES,
    getCustomPracticeExamReferencesSaga,
  );
}

export function* watchGetAvailableChapters() {
  yield takeLatest(
    personalizedStudyTypes.GET_AVAILABLE_CHAPTERS,
    getAvailableChaptersSaga,
  );
}

export function* watchSaveSelectedChapters() {
  yield takeLatest(
    personalizedStudyTypes.SAVE_SELECTED_CHAPTERS,
    saveSelectedChaptersSaga,
  );
}

export function* watchBuildChapterStudyPlan() {
  yield takeLatest(
    personalizedStudyTypes.BUILD_CHAPTER_STUDY_PLAN,
    buildChapterStudyPlanSaga,
  );
}

export function* watchLoadChapterStudyPlan() {
  yield takeLatest(
    personalizedStudyTypes.LOAD_CHAPTER_STUDY_PLAN,
    loadChapterStudyPlanSaga,
  );
}

export function* watchGetCustomPracticeExamSettings() {
  yield takeLatest(
    practiceExamTypes.GET_CUSTOM_PRACTICE_EXAM_SETTINGS,
    getCustomPracticeExamSettingsSaga,
  );
}

export function* watchFetchPendingSelfPromotions() {
  yield takeLatest(
    selfPromotionTypes.FETCH_PENDING_SELF_PROMOTIONS,
    fetchPendingSelfPromotionsSaga,
  );
}

export function* watchAnswerSelfPromotion() {
  yield takeLatest(
    selfPromotionTypes.ANSWER_SELF_PROMOTION,
    answerSelfPromotionSaga,
  );
}

function* fetchPendingSelfPromotionsSaga() {
  try {
    yield put({
      type: selfPromotionTypes.SET_PENDING_SELF_PROMOTIONS_LOADING,
      loading: true,
    });
    yield put({
      type: selfPromotionTypes.SET_PENDING_SELF_PROMOTIONS_ERROR,
      error: null,
    });

    const pending = yield call(getPendingSelfPromotionsService);
    yield put({
      type: selfPromotionTypes.SET_PENDING_SELF_PROMOTIONS,
      pending,
    });
  } catch (error) {
    yield put({
      type: selfPromotionTypes.SET_PENDING_SELF_PROMOTIONS_ERROR,
      error:
        error.response?.data?.error || 'Error fetching self-promotion status',
    });
  } finally {
    yield put({
      type: selfPromotionTypes.SET_PENDING_SELF_PROMOTIONS_LOADING,
      loading: false,
    });
  }
}

function* answerSelfPromotionSaga(action) {
  try {
    yield put({
      type: selfPromotionTypes.SET_ANSWERING_SELF_PROMOTION,
      answering: true,
    });
    yield put({
      type: selfPromotionTypes.SET_ANSWER_SELF_PROMOTION_ERROR,
      error: null,
    });

    yield call(
      answerSelfPromotionService,
      action.cycleId,
      action.rank,
      action.answer,
    );
    yield put({
      type: selfPromotionTypes.REMOVE_PENDING_SELF_PROMOTION,
      configId: action.configId,
    });
  } catch (error) {
    yield put({
      type: selfPromotionTypes.SET_ANSWER_SELF_PROMOTION_ERROR,
      error:
        error.response?.data?.error || 'Error submitting self-promotion answer',
    });
  } finally {
    yield put({
      type: selfPromotionTypes.SET_ANSWERING_SELF_PROMOTION,
      answering: false,
    });
  }
}

export function* watchGetCustomSync() {
  yield takeLatest(accountSettingsTypes.GET_CUSTOM_SYNC, getCustomSyncSaga);
}
export function* watchUpdateCustomSync() {
  yield takeLatest(
    accountSettingsTypes.UPDATE_CUSTOM_SYNC,
    updateCustomSyncSaga,
  );
}
